import { navigationItems } from "@config";
import { authInfoSelect } from "@entities/auth";
import { useSelector } from "react-redux";

export const useNavbarData = () => {
  const { user, shop } = useSelector(authInfoSelect);

  const navMenuItems = shop ? navigationItems(shop.role.acl) : null;

  return { user, shop, navMenuItems };
};
